
export { CollectibleCard } from "/home/runner/work/capsicum/capsicum/libs/features/digital-collectibles/web/src/ui/collectible-card/CollectibleCard.tsx"
export { CollectibleCardSkeleton } from "/home/runner/work/capsicum/capsicum/libs/features/digital-collectibles/web/src/ui/collectible-card/CollectibleCard.tsx"